var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.containerComponent,
    {
      directives: [
        {
          name: "animate-css",
          rawName: "v-animate-css",
          value: _vm.animation,
          expression: "animation",
        },
      ],
      tag: "component",
      staticClass: "brb-pagination",
    },
    [
      _vm.total > _vm.perPage
        ? _c("b-pagination", {
            staticClass: "m-0 p-0",
            attrs: {
              "per-page": _vm.perPage,
              "total-rows": _vm.total,
              pills: "",
            },
            model: {
              value: _vm.page,
              callback: function ($$v) {
                _vm.page = $$v
              },
              expression: "page",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }